module.exports = __webpack_public_path__ + "684b6938f4364d91b70ec5abafa92caf.pdf";